
enum IdentityType {
    Guest,
    UsernamePassword,
    ActiveDirectory,
    OAuth
}

export default IdentityType;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/identityType.ts